import { useContext, useMemo } from 'react';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import {
  useWizardService,
  getCurrentStepId,
} from '@bingads-webui-react/wizard';
import { PMAX_LITE_WIZARD_STEP_PATHS } from '@bingads-webui-campaign-react/pmax-lite-wizard-utils';

const DISABLED_ON_ITEM_CLICK_FN = () => undefined;

export const useStepListConfig = () => {
  const i18n = useContext(I18nContext);
  const { state } = useWizardService();

  // In Add funds step, account and campaign should already be activated, user cannot go back
  const disableActionInStepList = getCurrentStepId(state) === PMAX_LITE_WIZARD_STEP_PATHS.ADD_FUNDS
    || getCurrentStepId(state) === PMAX_LITE_WIZARD_STEP_PATHS.PREVIEW_ADD_FUNDS;

  // Add some onboarding step id in config so user can click back button on horizontal step list
  const config = useMemo(() => ([{
    id: PMAX_LITE_WIZARD_STEP_PATHS.CAMPAIGN_MODE,
  }, {
    id: PMAX_LITE_WIZARD_STEP_PATHS.SMART_PAGE_EDITOR,
  }, {
    id: PMAX_LITE_WIZARD_STEP_PATHS.SMART_PAGE_CUSTOM_DOMAIN,
  }, {
    id: PMAX_LITE_WIZARD_STEP_PATHS.AD_ASSETS,
    title: i18n.getString(_TL_('Asset group')),
  }, {
    id: PMAX_LITE_WIZARD_STEP_PATHS.TARGETING,
    title: i18n.getString(_TL_('Targeting')),
  }, {
    id: PMAX_LITE_WIZARD_STEP_PATHS.BUDGET,
    title: i18n.getString(_TL_('Budget & bid strategy')),
  }, {
    id: PMAX_LITE_WIZARD_STEP_PATHS.PREVIEW_ASSETS,
    title: i18n.getString(_TL_('Preview campaign')),
  }, {
    id: PMAX_LITE_WIZARD_STEP_PATHS.ACCOUNT_DETAILS,
    title: i18n.getString(_TL_('Account details')),
  }, {
    id: PMAX_LITE_WIZARD_STEP_PATHS.PAYMENT,
    title: i18n.getString(_TL_('Payment')),
  }, {
    id: PMAX_LITE_WIZARD_STEP_PATHS.ADD_FUNDS,
    title: i18n.getString(_TL_('Add funds')),
  }, {
    id: PMAX_LITE_WIZARD_STEP_PATHS.PREVIEW_ACCOUNT,
    title: i18n.getString(_TL_('Account details')),
  }, {
    id: PMAX_LITE_WIZARD_STEP_PATHS.PREVIEW_PAYMENT,
    title: i18n.getString(_TL_('Payment')),
  }, {
    id: PMAX_LITE_WIZARD_STEP_PATHS.PREVIEW_ADD_FUNDS,
    title: i18n.getString(_TL_('Add funds')),
  }, {
    id: PMAX_LITE_WIZARD_STEP_PATHS.CONVERSION_UPSELL,
  }]), [i18n]);

  return useMemo(() => ({
    config,
    getOnItemClickFn: disableActionInStepList ? DISABLED_ON_ITEM_CLICK_FN : undefined,
  }), [config, disableActionInStepList]);
};
